// Basic static experts data; replace with backend fetch later.
// handle should be unique and URL-safe.
export const experts = [
    {
        uid: 'lw8qu6X8kiWWQOvIkEnSzYYW4Kk2',
        handle: 'dana.scully',
        displayName: 'Dana Scully',
        title: 'Security Analyst',
        office: 'Nuclear Proliferation & Strategic Threats',
        location: 'Washington, DC',
        email: 'dana.scully@x-files.com',
        clearance: 'TS/SCI',
        arr: ['Nuclear Proliferation', 'Strategic Alliances'],
        organization: 'FBI',
        relevance: 'high',
        photo: '/assets/dana.jpg',
        cellPhone: '202-555-0701',
        landline: '202-555-0702',
        tsVoip: '555-7001',
        expertise: 'Security analyst focused on nuclear proliferation, missile programs, post-strike assessments, and anti-Western strategic alliances.',
        specialties: ['Nuclear Proliferation', 'Missile Programs', 'Military Assessments', 'Strategic Alliances', 'Nonproliferation Policy'],
        languages: ['English (Native)', 'Spanish (ILR 2)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'Nuclear Proliferation', proficiency: 'expert'},
                {domain: 'Missile Programs', proficiency: 'expert'},
                {domain: 'Strategic Alliances', proficiency: 'advanced'},
                {domain: 'Nonproliferation Policy', proficiency: 'advanced'}
            ],
            collectionSources: ['SIGINT', 'IMINT', 'HUMINT'],
            regionalExpertise: ['Korean Peninsula', 'Russia'],
            evidenceRequirements: {
                minimumSources: 2,
                acceptsSingleSource: false
            },
            analyticalApproach: 'risk-assessment focused on proliferation threats and strategic transfers'
        }

    },
    {
        uid: 'BV1KHailTbZx2Qk3vTu0hxbS37o2',
        handle: 'fox.mulder',
        displayName: 'Fox Mulder',
        title: 'Strategic Supply-Chain Analyst',
        office: 'National Security & Critical Infrastructure',
        location: 'Washington, DC',
        email: 'fox.mulder@x-files.com',
        clearance: 'TS/SCI',
        arr: ['Critical Minerals', 'China Supply Chains'],
        organization: 'FBI',
        relevance: 'high',
        photo: '/assets/fox.jpg',
        cellPhone: '202-555-0801',
        landline: '202-555-0802',
        tsVoip: '555-8001',
        expertise: 'Strategic supply-chain and national security analyst focused on foreign ownership, critical-minerals dependencies, and China\'s influence on U.S. energy industries.',
        specialties: ['Critical Minerals', 'China Supply Chains', 'Foreign Investment', 'Energy Security', 'Policy Risk'],
        languages: ['English (Native)', 'German (ILR 1+)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'Critical Minerals', proficiency: 'expert'},
                {domain: 'China Supply Chains', proficiency: 'expert'},
                {domain: 'Foreign Investment', proficiency: 'advanced'},
                {domain: 'Energy Security', proficiency: 'advanced'},
                {domain: 'Policy Risk', proficiency: 'intermediate'}
            ],
            collectionSources: ['OSINT', 'HUMINT', 'SIGINT'],
            regionalExpertise: ['China', 'Southeast Asia', 'Central Asia'],
            evidenceRequirements: {
                minimumSources: 2,
                acceptsSingleSource: false
            },
            analyticalApproach: 'supply-chain analysis focused on foreign dependencies and strategic vulnerabilities'
        }

    },
    {
        uid: 'pJtZn6PzqsUGQj8BGHvgurhCjUj2',
        handle: 'alex.krycek',
        displayName: 'Alex Krycek',
        title: 'Maritime Sanctions Analyst',
        office: 'Maritime Interdiction & Sanctions Enforcement',
        location: 'Washington, DC',
        email: 'alex.krycek@x-files.com',
        clearance: 'TS/SCI',
        arr: ['Maritime Sanctions', 'Shadow Fleets'],
        organization: 'FBI',
        relevance: 'high',
        photo: '/assets/alex.jpg',
        cellPhone: '202-555-0901',
        landline: '202-555-0902',
        tsVoip: '555-9001',
        expertise: 'Maritime sanctions and shadow-fleet interdiction analyst specializing in illicit oil trafficking and AIS anomaly detection.',
        specialties: ['Maritime Sanctions', 'Shadow Fleets', 'AIS Analysis', 'Oil Smuggling', 'Illicit Trade'],
        languages: ['English (Native)', 'Russian (ILR 2+)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'Maritime Sanctions', proficiency: 'expert'},
                {domain: 'Shadow Fleets', proficiency: 'expert'},
                {domain: 'AIS Analysis', proficiency: 'advanced'},
                {domain: 'Oil Smuggling', proficiency: 'expert'},
                {domain: 'Illicit Trade', proficiency: 'advanced'}
            ],
            collectionSources: ['SIGINT', 'IMINT', 'OSINT', 'HUMINT'],
            regionalExpertise: ['Middle East', 'Europe', 'Asia-Pacific'],
            evidenceRequirements: {
                minimumSources: 2,
                acceptsSingleSource: false
            },
            analyticalApproach: 'maritime interdiction focused on detecting and disrupting illicit trade networks'
        }
    },
    {
        uid: 'O81g3yuDdwh8IDCjYbWSSc9hZyp1',
        handle: 'john.dogget',
        displayName: 'John Dogget',
        title: 'Counterintelligence Lead',
        office: 'Counterintelligence & Insider Threat',
        location: 'Washington, DC',
        email: 'john.dogget@x-files.com',
        clearance: 'TS/SCI',
        arr: ['Counterintelligence', 'Insider Threat'],
        organization: 'FBI',
        relevance: 'high',
        photo: '/assets/john.jpg',
        cellPhone: '202-555-1003',
        landline: '202-555-1004',
        tsVoip: '555-1003',
        expertise: 'Counterintelligence lead focused on insider-threat detection, foreign intelligence tradecraft, and operational risk management across sensitive programs.',
        specialties: ['Insider Threat', 'Counterintelligence', 'Operational Security', 'Foreign Intelligence Tradecraft', 'Risk Management'],
        languages: ['English (Native)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'Counterintelligence', proficiency: 'expert'},
                {domain: 'Insider Threat', proficiency: 'expert'},
                {domain: 'Operational Security', proficiency: 'advanced'},
                {domain: 'Risk Management', proficiency: 'advanced'}
            ],
            collectionSources: ['HUMINT', 'SIGINT', 'OSINT'],
            regionalExpertise: ['United States', 'Europe'],
            evidenceRequirements: {
                minimumSources: 2,
                acceptsSingleSource: false
            },
            analyticalApproach: 'counterintelligence analysis focused on anomaly detection, intent assessment, and mitigating compromise risk'
        }
    },
    {
        handle: 'dana.scott',
        displayName: 'Dana Scott',
        title: 'Senior Regional Analyst',
        office: 'J2 / All-Source Analysis',
        location: 'Washington, DC',
        email: 'dana.scott@ic.example.mil',
        clearance: 'TS/SCI',
        arr: ['Sahel', 'West Africa'],
        organization: 'CENTCOM',
        relevance: 'high',
        photo: '/assets/avatars/1.jpg',
        cellPhone: '202-555-0101',
        landline: '202-555-0102',
        tsVoip: '555-1001',
        specialties: ['Political stability', 'Militant group dynamics', 'Early warning'],
        languages: ['French (ILR 3)', 'Arabic (ILR 2+)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'Political Stability', proficiency: 'expert'},
                {domain: 'Militant Group Dynamics', proficiency: 'expert'},
                {domain: 'Early Warning', proficiency: 'advanced'}
            ],
            collectionSources: ['HUMINT', 'SIGINT', 'OSINT'],
            regionalExpertise: ['Sahel', 'West Africa'],
            evidenceRequirements: {
                minimumSources: 2,
                acceptsSingleSource: false
            },
            analyticalApproach: 'regional analysis focused on political-military dynamics and early warning indicators'
        }

    },
    {
        handle: 'alvin.robertson',
        displayName: 'Alvin Robertson',
        title: 'Defense Intelligence Analyst',
        office: 'Maritime & Counter-Piracy Cell',
        location: 'Norfolk, VA',
        email: 'alvin.robertson@ic.example.mil',
        clearance: 'TS/SCI',
        arr: ['Yemen', 'Gulf of Aden'],
        organization: 'JIC',
        relevance: 'medium',
        photo: '/assets/avatars/3.jpg',
        cellPhone: '202-555-0201',
        landline: '202-555-0202',
        tsVoip: '555-2001',
        specialties: ['Maritime security', 'A2/AD assessment', 'Order of battle'],
        languages: ['Arabic (ILR 2)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'Maritime Security', proficiency: 'expert'},
                {domain: 'A2/AD Assessment', proficiency: 'advanced'},
                {domain: 'Order of Battle', proficiency: 'expert'}
            ],
            collectionSources: ['IMINT', 'SIGINT', 'OSINT'],
            regionalExpertise: ['Yemen', 'Gulf of Aden'],
            evidenceRequirements: {
                minimumSources: 2,
                acceptsSingleSource: false
            },
            analyticalApproach: 'defense intelligence focused on maritime threats and military capabilities'
        }
    },
    {
        handle: 'monica.blake',
        displayName: 'Monica Blake',
        title: 'All-Source Analyst',
        office: 'East Africa Mission Team',
        location: 'Fort Meade, MD',
        email: 'monica.blake@ic.example.mil',
        clearance: 'TS/SCI',
        arr: ['Horn of Africa', 'East Africa'],
        organization: 'DIA',
        relevance: 'low',
        photo: '/assets/avatars/2.jpg',
        cellPhone: '202-555-0301',
        landline: '202-555-0302',
        tsVoip: '555-3001',
        specialties: ['Humanitarian access', 'Border security', 'Political-military analysis'],
        languages: ['Somali (ILR 2)', 'French (ILR 2)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'Humanitarian Access', proficiency: 'advanced'},
                {domain: 'Border Security', proficiency: 'expert'},
                {domain: 'Political-Military Analysis', proficiency: 'advanced'}
            ],
            collectionSources: ['HUMINT', 'OSINT', 'IMINT'],
            regionalExpertise: ['Horn of Africa', 'East Africa'],
            evidenceRequirements: {
                minimumSources: 1,
                acceptsSingleSource: true
            },
            analyticalApproach: 'all-source analysis focused on humanitarian and border security issues'
        }
    },
    {
        handle: 'john.keller',
        displayName: 'John Keller',
        title: 'Regional Analyst',
        office: 'Mediterranean Desk',
        location: 'Dayton, OH',
        email: 'john.keller@ic.example.mil',
        clearance: 'TS/SCI',
        arr: ['Levant', 'Mediterranean'],
        organization: 'NASIC',
        relevance: 'medium',
        photo: '/assets/avatars/4.jpg',
        cellPhone: '202-555-0401',
        landline: '202-555-0402',
        tsVoip: '555-4001',
        specialties: ['Air & missile threat', 'Capability forecasting', 'Technical exploitation'],
        languages: ['Arabic (ILR 2+)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'Air & Missile Threat', proficiency: 'expert'},
                {domain: 'Capability Forecasting', proficiency: 'expert'},
                {domain: 'Technical Exploitation', proficiency: 'advanced'}
            ],
            collectionSources: ['IMINT', 'SIGINT', 'MASINT'],
            regionalExpertise: ['Levant', 'Mediterranean'],
            evidenceRequirements: {
                minimumSources: 2,
                acceptsSingleSource: false
            },
            analyticalApproach: 'technical intelligence focused on air and missile capabilities'
        }
    },
    {
        handle: 'walter.lin',
        displayName: 'Walter Lin',
        title: 'Senior Country Desk Officer',
        office: 'South & Central Asia Division',
        location: 'Springfield, VA',
        email: 'walter.lin@ic.example.mil',
        clearance: 'TS/SCI',
        arr: ['Afghanistan', 'Pakistan'],
        organization: 'NGA',
        relevance: 'high',
        photo: '/assets/avatars/6.jpg',
        cellPhone: '202-555-0501',
        landline: '202-555-0502',
        tsVoip: '555-5001',
        specialties: ['GEOINT integration', 'Target development', 'Terrain & mobility'],
        languages: ['Dari (ILR 2)', 'Urdu (ILR 2)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'GEOINT Integration', proficiency: 'expert'},
                {domain: 'Target Development', proficiency: 'expert'},
                {domain: 'Terrain & Mobility', proficiency: 'advanced'}
            ],
            collectionSources: ['GEOINT', 'IMINT', 'HUMINT'],
            regionalExpertise: ['Afghanistan', 'Pakistan'],
            evidenceRequirements: {
                minimumSources: 2,
                acceptsSingleSource: false
            },
            analyticalApproach: 'geospatial analysis focused on target development and operational planning'
        }
    },
    {
        handle: 'fox.morgan',
        displayName: 'Fox Morgan',
        title: 'Analytic Methodologist',
        office: 'Tradecraft & Quality',
        location: 'Washington, DC',
        email: 'fox.morgan@ic.example.mil',
        clearance: 'TS/SCI',
        arr: ['West Africa', 'Sahel'],
        organization: 'NIWC Atlantic',
        relevance: 'low',
        photo: '/assets/avatars/7.jpg',
        cellPhone: '202-555-0601',
        landline: '202-555-0602',
        tsVoip: '555-6001',
        specialties: ['Structured analytics', 'Evidence evaluation', 'Collection-to-analysis workflow'],
        languages: ['French (ILR 2+)'],
        analyticProfile: {
            focusAreas: [
                {domain: 'Structured Analytics', proficiency: 'expert'},
                {domain: 'Evidence Evaluation', proficiency: 'expert'},
                {domain: 'Collection-to-Analysis Workflow', proficiency: 'advanced'}
            ],
            collectionSources: ['OSINT', 'All-Source'],
            regionalExpertise: ['West Africa', 'Sahel'],
            evidenceRequirements: {
                minimumSources: 2,
                acceptsSingleSource: false
            },
            analyticalApproach: 'methodological focus on tradecraft, evidence standards, and analytical rigor'
        }
    }
];

export function getExpertByHandle(handle) {
    return experts.find(e => e.handle === handle);
}

export function getExpertByUid(uid) {
    return experts.find(e => e.uid === uid);
}

export function getExpertsWithUid() {
    // Returns only the first 3 experts with UIDs
    return experts.filter(e => e.uid).slice(0, 3);
}
